import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={movie.coverImage}
          alt={movie.title}
          title={`${movie.title} - 桃子影院高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-white text-xs leading-relaxed line-clamp-3">
              {movie.description}
            </p>
          </div>
        </div>
        <div className="absolute top-2 left-2">
          <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-white whitespace-nowrap">
            {movie.quality}
          </span>
        </div>
        {movie.isNew && (
          <div className="absolute top-2 right-2">
            <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-white whitespace-nowrap">
              NEW
            </span>
          </div>
        )}
        <div className="absolute bottom-2 right-2">
          <span className="text-xs font-bold text-white bg-black/60 px-1.5 py-0.5 rounded whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{movie.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{movie.subcategory}</span>
        </div>
      </div>
    </Link>
  );
}